import { useEffect, useState } from 'react';

/**
 * Architectural summary: Tracks window width for responsive POS layout decisions
 * and updates on resize events.
 */
export function useViewportWidth() {
  const [viewportWidth, setViewportWidth] = useState(() =>
    (typeof window === 'undefined' ? 1280 : window.innerWidth),
  );

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return viewportWidth;
}
